export const ATUALIZADO = 'Filial atualizada'
export const CADASTRADO = 'Filial adicionada'
export const NAO_ENCONTRADO = 'Não foram encontradas filiais cadastradas'
export const NAO_ENCONTRADO_FILTRO = 'Não há filiais com esse filtro'
